import {observable} from "mobx";
import {consoleApi} from "../apiMiddleware";
import {message} from "antd";
import {StorageType} from "../components/portal/driverComponents/AddStorageDriver";
import { getCurrentLan } from "@netless/i18n-react-router";
import {ServiceTypeEnum} from "../components/portal/serviceCenter/ProjectDetail";

export type tagType = { id: number, relationServices: string[], type: string };


export type StorageDriversInfType = {
    ak: string,
    sk: string,
    bucket: string,
    region: string,
    provider: StorageType,
    path: string,
    domain?: string,
};

export type StorageDriversArrayInfType = {
    id: number,
    teamId: number,
    provider: StorageType,
    type: string,
    ak: string,
    sk: string,
    bucket: string,
    region: string,
    path: string,
    createdAt: string,
    updatedAt: string,
    domain?: string;
};


export type DriverInfType = {
    type: ServiceTypeEnum,
    configuration: {
        storageDriverId?: number,
        defaultStorageDriver?: boolean,
    },
};

export type ServiceInfType = {
    id: number;
    teamId: number;
    enable: boolean;
    type: ServiceTypeEnum;
    configuration: string;
    createdAt: string;
    updatedAt: string;
};

export class DriverStore {
    @observable
    public storageDriversList: StorageDriversArrayInfType[] = [];
    @observable
    public currentStorageDriversList: StorageDriversArrayInfType[] = [];
    @observable
    public currentStorageDriver: StorageDriversArrayInfType;
    @observable
    public storageTagArray: tagType[] = [];
    @observable
    public rtcTagArray: tagType[] = [];
    @observable
    public serviceInf: ServiceInfType | undefined;
    @observable
    public static_conversion: number = 1;
    @observable
    public dynamic_conversion: number = 1;

    // 存储相关 Drive
    // 获取全部的存储 Drive
    public async getAllStorageDrivers(): Promise<void> {
        try {
            const resp = await consoleApi.driver.getStorageDriversList();
            if (resp.code === 200) {
                this.storageDriversList = resp.data.storageDrivers;
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    // 获取某个 id 下的存储 Drive
    public async getStorageDriversById(id: number): Promise<void> {
        try {
            const res = await consoleApi.driver.getStorageDriverById(id);
            if (res.code === 200) {
                console.log(res);
                this.currentStorageDriver = res.data.storageDriver;
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    // 提交存储 Drive
    public async submitStorageDriver(storageDriversInfType: StorageDriversInfType): Promise<void> {
        try {
            const resp = await consoleApi.driver.submitStorageDriverInf(storageDriversInfType);
            if (resp.code === 200) {
                message.success("添加成功");
                console.log(resp);
                await this.getAllStorageDrivers();
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    // 提交且更新存储
    public async submitAndUpdateStorageDriver(storageDriversInfType: StorageDriversInfType, type: ServiceTypeEnum): Promise<void> {
        try {
            const resp = await consoleApi.driver.submitStorageDriverInf(storageDriversInfType);
            if (resp.code === 200) {
                if (driverStore.serviceInf && !driverStore.serviceInf.enable) {
                    await consoleApi.driver.upDateServiceDriver({
                        type: type,
                        configuration: {
                            storageDriverId: resp.data.storageDriver.id,
                        },
                    });
                    await this.switchService(type, true);
                } else {
                    await this.submitDriveInService({
                        type: type,
                        configuration: {
                            storageDriverId: resp.data.storageDriver.id,
                        },
                    });
                }
                await this.getAllStorageDrivers();
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    // 更新存储 Drive
    public async upDateStorageDriver(storageDriversInfType: StorageDriversInfType, id: number): Promise<void> {
        try {
            const resp = await consoleApi.driver.upDateStorageDriverInf(storageDriversInfType, id);
            if (resp.code === 200) {
                message.success("更新成功");
                await this.getAllStorageDrivers();
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    // 删除特定的存储 Drive
    public async deleteStorageDriver(id: number): Promise<void> {
        const isEnglish: boolean = getCurrentLan() === "en";
        try {
            const resp = await consoleApi.driver.deleteStorageDriverById(id);
            if (resp.code === 200) {
                await this.getAllStorageDrivers();
                message.success(isEnglish ? "successfully deleted" : "删除成功");
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    // 提交 Service 下的 Drive

    public async getServiceInfByType(type: ServiceTypeEnum): Promise<void> {
        try {
            const resp = await consoleApi.driver.getServiceState(type);
            if (resp.code === 200) {
                this.serviceInf = resp.data.services[0];
            }
        } catch (err) {
            message.error(err.message);
        }
    }
    public async submitDriveInService(driverInfType: DriverInfType): Promise<void> {
        const isEnglish: boolean = getCurrentLan() === "en";
        try {
            const resp = await consoleApi.driver.submitServiceDriver(driverInfType);
            if (resp.code === 200) {
                message.success(isEnglish ? "Open successfully" : "开启成功");
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    // 更新 Service 下的 Drive
    public async updateDriveInService(driverInfType: DriverInfType): Promise<void> {
        const isEnglish: boolean = getCurrentLan() === "en";
        try {
            const resp = await consoleApi.driver.upDateServiceDriver(driverInfType);
            if (resp.code === 200) {
                message.success(isEnglish ? "Update completed" : "更新成功");
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    // 开关 Service
    public async switchService(service: ServiceTypeEnum, state: boolean): Promise<void> {
        const isEnglish: boolean = getCurrentLan() === "en";
        try {
            const resp = await consoleApi.driver.switchServiceState(service, state);
            if (resp.code === 200) {
                if (state) {
                    message.success(isEnglish ? "Open successfully" : "开启成功");
                    await this.getServiceInfByType(service);
                } else {
                    message.success(isEnglish ? "Closed successfully" : "关闭成功");
                }
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    // 开关获取 QPS
    public async getServiceQPS(service: ServiceTypeEnum): Promise<void> {
        try {
            const resp = await consoleApi.driver.getServiceQPS(service);
            if (resp.code === 200) {
                if (service === ServiceTypeEnum.static_conversion) {
                    this.static_conversion = resp.data.concurrentSettings[0].maxConcurrentNumber;
                } else {
                    this.dynamic_conversion = resp.data.concurrentSettings[0].maxConcurrentNumber;
                }
            }
        } catch (err) {
            message.error(err.message);
        }
    }

}
export const driverStore = new DriverStore();



// WEBPACK FOOTER //
// ./src/models/DriverStore.ts